var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"size":"small","type":"success"},on:{"click":function($event){return _vm.confirm()}}},[_vm._v("Confirm")]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'Answer'}}},[_vm._v("Answer")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76082e4e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AssessmentConfirm.vue
// module id = Ccme
// module chunks = 2